import { createRoot } from 'react-dom/client';
import { I18nProvider, translate } from 'shared/lib/i18n.tsx';
import { TvPage } from './ui/TvPage.tsx';

function getChromiumVersion(): number | null {
  const match = navigator.userAgent.match(/(?:Chrome|CrMo|CriOS)\/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

function isBrowserSupported(): boolean {
  try {
    const chromiumVersion = getChromiumVersion();
    if (chromiumVersion !== null && chromiumVersion < 84) return false;

    return (
      typeof RTCPeerConnection !== 'undefined' &&
      typeof WebSocket !== 'undefined' &&
      typeof Promise !== 'undefined' &&
      typeof fetch !== 'undefined' &&
      typeof CSS !== 'undefined' &&
      CSS.supports('display', 'grid') &&
      CSS.supports('display', 'flex')
    );
  } catch {
    return false;
  }
}

if (!isBrowserSupported()) {
  document.body.innerHTML = `
    <div style="
      width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;
      background: #0a0015 url('/images/bgTv.jpg') center / cover no-repeat;
      font-family: ui-sans-serif, system-ui, 'Segoe UI', sans-serif;
      box-sizing:border-box;
    ">
      <div style="
        width:130px;height:130px;border-radius:50%;
        background:rgba(190,185,210,0.85);
        display:flex;align-items:center;justify-content:center;
      ">
        <img src="/icons/do_not_disturb_on.svg" width="72" height="72" alt="" />
      </div>
      <h1 style="margin-top:28px;font-size:32px;font-weight:800;color:#fff;text-align:center;letter-spacing:-0.01em;">
        ${translate('tv.browser_outdated')}
      </h1>
      <p style="margin-top:12px;font-size:18px;color:rgba(255,255,255,0.6);text-align:center;line-height:1.6;max-width:700px;">
        ${translate('tv.browser_unsupported').replace(/\n/g, '<br>')}
      </p>
    </div>
  `;
} else {
  const el = document.getElementById('root');
  if (!el) throw new Error('TV app: missing #root');
  createRoot(el).render(<I18nProvider><TvPage /></I18nProvider>);
}
